import { useThemeMode } from "../../../context/contextTheme";
import { useAwsUrl } from "../../../context/Dashboard/aws/contextUrl";
import { ResponsiveContainer, PieChart, Pie, Legend, Tooltip } from "recharts";

const PieChartGraph = () => {
  const { theme } = useThemeMode();
  const { wCV, wHC, wMC, wLC, urlVulTableAll, urlAssets } = useAwsUrl();
  
  const webData = [
    { name: 'Critical', value: wCV, fill: "#6d2d9d" },
    { name: 'High', value: wHC, fill: "#fc0000" },
    { name: 'Medium', value: wMC, fill: "#ffc000" },
    { name: 'Low', value: wLC, fill: "#92d14f" },
    // { name: 'Save Score', vulnerabilities: wSS, fill: "#ffffff" },
  ].reverse();

  const renderCustomizedLabel = ({ name, value }) => `${name}: ${value}`;
  const filteredPieData = webData.filter((data) => data.value > 0);

  return (
    <div className="p-2">
      <div
        className="card rounded-4 shadow-sm"
        style={{ 
          width: 'calc(620px + 1rem)',
          height: 400, 
          backgroundColor: theme.background,
          border: `1px solid ${theme.border}`
        }}>
        <div className="card-body">
          <h6 className="card-title fw-semibold text-center mt-4" 
            style={{ fontSize: 20, color: theme.textColor }}>
            Web Vulnerability Distribution
          </h6>
          {urlAssets === null ? (
            <div className="h-75 d-flex flex-column justify-content-center align-items-center">
              <p className="fs-5 fw-semibold text-muted mt-2">
                Initiated the scan to get the pie data.
              </p>
            </div>
          ) : urlVulTableAll == [] ? (
            <div className="h-75 d-flex flex-column justify-content-center align-items-center">
              <i className="bi bi-shield-fill-check fs-1 text-muted"></i>
              <p className="fw-semibold text-muted mt-2">
                No Web vulnerabilities detected. Pie data is not available.
              </p>
            </div>
          ) : (
            <div className="p-2">
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={filteredPieData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    innerRadius={80}
                    outerRadius={100}
                    label={renderCustomizedLabel}
                  />
                  <Legend
                    iconSize={10}
                    layout="vertical"
                    verticalAlign="middle"
                    align="right"
                  />
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PieChartGraph;
